import React from "react";
import { Grid, Typography} from "@mui/material";

import {iDisciplina} from "../../types/Discplina";
import AlunoTabDiscDiscMod from "./AlunoTabDiscDiscMod";
import {useSelector} from "react-redux";
import {RootState} from "../../store/reducers";
import { sharedStyles } from "./alunoDialogStyles";

const sxStyles = {
    mainGrid: {
        display: 'flex',
        alignContent: 'flex-start',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        marginBottom: '15px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '10px',
        backgroundColor: 'grey.200',
        borderColor: 'divider',
    },
    discGrid: sharedStyles.containerRowNoWrap,
}

interface iDiscDialog  {
    registro: iDisciplina,
    eilId: number,
    allModules: string[]
}


const AlunoTabDiscDisc = ({ registro, eilId, allModules  } : iDiscDialog ) => {

    const dof = useSelector( (state : RootState) => state.cadastros.dof );

    // Mapa de Description -> modulo para acesso rapido
    const dmByDesc: Record<string, any> = {};
    if (registro?.disciplineModule) {
        registro.disciplineModule.forEach((dm: any) => {
            if (dm.Description) dmByDesc[dm.Description] = dm;
        });
    }

    // Cada modulo mantem uma largura legivel. Quando a matriz tiver muitas
    // etapas, a faixa passa a rolar horizontalmente em vez de comprimir os
    // dados da matricula.
    const moduleWidth = '420px';


    return (<React.Fragment>
                <Grid container sx={{...sxStyles.mainGrid}}>
                    <Grid item sx={{...sxStyles.discGrid, borderLeft: '3px solid', borderLeftColor: 'primary.light', pl: 1}} sm={12} md={3} lg={3} xl={3}>
                        <Typography variant="body2" sx={{ fontWeight: 'medium' }}>{registro.Description}</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>#{registro.id}</Typography>
                    </Grid>

                    <Grid item sx={{
                        ...sxStyles.discGrid,
                        flexWrap: 'nowrap',
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        alignItems: 'stretch',
                        paddingBottom: '6px',
                    }} sm={12} md={9} lg={9} xl={9}>
                    {
                        allModules.map( (modDesc: string, ix: number) => {
                            const dm = dmByDesc[modDesc];
                            if (!dm) {
                                // Coluna vazia para manter alinhamento
                                return (
                                    <Grid key={ix} item sx={{ flex: '0 0 auto', maxWidth: moduleWidth, minWidth: moduleWidth, padding: '5px' }} />
                                );
                            }

                            const doff = dof.filter( (d: any) => d.DisciplineModule_id === dm.id )

                            const dofParaMatricula = dof.filter( (d: any) => d.DisciplineModule_id === dm.id
                                && d.isEnrollmentClosed !== true
                                && d.classOffer?.isEnrollmentClosed !== true &&
                                d.EndDate > new Date().toISOString()
                            )

                            return (
                                    <AlunoTabDiscDiscMod key={ix} registro={dm} eilId={eilId} dof={doff} dofParaMatricula={dofParaMatricula} colWidth={moduleWidth} />
                            )
                        })

                    }


                    </Grid>



                </Grid>
    </React.Fragment>);
}
export default (AlunoTabDiscDisc);
